<template>
  <editor :id="id" default-tab="account" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Account from './editor/Account'
import ChangePassword from './editor/ChangePassword'
import Access from './editor/Access'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Account",          name: "account",              component: Account},
        {title: "Change password",  name: "change_password",      component: ChangePassword, edit_only: true},
        {title: "Access",           name: "access",               component: Access, edit_only: true}
      ]
    }
  }
}
</script>
